import PickGroup, { PickGroupProps } from "@/components/pick/group";
import Icon from "@/components/primitives/icon";
import { formatNumber } from "@/utils";
import React from "react";

export interface PickChipProps extends PickGroupProps {
  idKey?: string;
  color?: "neutral" | "white";
  totalPicks: number;
  showAvatars?: boolean;
  totalComments?: number;
  showComments?: boolean;
}

export default function PickChip(props: PickChipProps) {
  return (
    <div
      className={`bg-surface inline-flex flex-row whitespace-nowrap px-2 py-1 rounded-full justify-center items-center text-title-sm-bold text-secondary-100 uppercase gap-2 ${
        props.showAvatars === undefined || props.showAvatars === true
          ? "h-8"
          : "h-[22px]"
      } shadow-[0px_4px_16px_0px_#21273514]
  `}
    >
      <div className="flex flex-row gap-1 items-center">
        {props.totalPicks && props.totalPicks > 0 ? (
          <svg width="16" height="11" viewBox="0 0 16 11" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 10.334H15C15.2652 10.334 15.5196 10.2286 15.7071 10.0411C15.8946 9.85355 16 9.5992 16 9.33398V7.26398C15.9994 7.1545 15.9629 7.04825 15.896 6.96154C15.8292 6.87483 15.7357 6.81245 15.63 6.78398C15.3101 6.69925 15.0272 6.5111 14.8253 6.24884C14.6235 5.98658 14.5141 5.66492 14.5141 5.33398C14.5141 5.00304 14.6235 4.68139 14.8253 4.41913C15.0272 4.15687 15.3101 3.96872 15.63 3.88398C15.7357 3.85552 15.8292 3.79314 15.896 3.70643C15.9629 3.61972 15.9994 3.51347 16 3.40398V1.33398C16 1.06877 15.8946 0.814414 15.7071 0.626878C15.5196 0.439341 15.2652 0.333984 15 0.333984H1C0.734784 0.333984 0.48043 0.439341 0.292893 0.626878C0.105357 0.814414 0 1.06877 0 1.33398V3.40398C0.000614515 3.51347 0.0371467 3.61972 0.103987 3.70643C0.170828 3.79314 0.264281 3.85552 0.37 3.88398C0.689909 3.96872 0.972816 4.15687 1.17466 4.41913C1.3765 4.68139 1.48594 5.00304 1.48594 5.33398C1.48594 5.66492 1.3765 5.98658 1.17466 6.24884C0.972816 6.5111 0.689909 6.69925 0.37 6.78398C0.264281 6.81245 0.170828 6.87483 0.103987 6.96154C0.0371467 7.04825 0.000614515 7.1545 0 7.26398V9.33398C0 9.5992 0.105357 9.85355 0.292893 10.0411C0.48043 10.2286 0.734784 10.334 1 10.334ZM4.25 1.33398C4.39834 1.33398 4.54334 1.37797 4.66668 1.46038C4.79001 1.54279 4.88614 1.65993 4.94291 1.79697C4.99967 1.93402 5.01453 2.08482 4.98559 2.2303C4.95665 2.37579 4.88522 2.50943 4.78033 2.61431C4.67544 2.7192 4.5418 2.79063 4.39632 2.81957C4.25083 2.84851 4.10003 2.83366 3.96299 2.77689C3.82594 2.72013 3.70881 2.624 3.6264 2.50066C3.54399 2.37733 3.5 2.23232 3.5 2.08398C3.50259 1.88588 3.58244 1.69661 3.72253 1.55652C3.86263 1.41642 4.05189 1.33657 4.25 1.33398ZM4.25 4.33398C4.39834 4.33398 4.54334 4.37797 4.66668 4.46038C4.79001 4.54279 4.88614 4.65993 4.94291 4.79697C4.99967 4.93402 5.01453 5.08482 4.98559 5.2303C4.95665 5.37579 4.88522 5.50943 4.78033 5.61431C4.67544 5.7192 4.5418 5.79063 4.39632 5.81957C4.25083 5.84851 4.10003 5.83366 3.96299 5.77689C3.82594 5.72013 3.70881 5.624 3.6264 5.50066C3.54399 5.37733 3.5 5.23232 3.5 5.08398C3.50259 4.88588 3.58244 4.69661 3.72253 4.55652C3.86263 4.41642 4.05189 4.33657 4.25 4.33398ZM4.25 7.33398C4.39834 7.33398 4.54334 7.37797 4.66668 7.46038C4.79001 7.54279 4.88614 7.65993 4.94291 7.79697C4.99967 7.93402 5.01453 8.08482 4.98559 8.2303C4.95665 8.37579 4.88522 8.50943 4.78033 8.61431C4.67544 8.7192 4.5418 8.79063 4.39632 8.81957C4.25083 8.84851 4.10003 8.83366 3.96299 8.77689C3.82594 8.72013 3.70881 8.624 3.6264 8.50066C3.54399 8.37733 3.5 8.23232 3.5 8.08398C3.50259 7.88588 3.58244 7.69661 3.72253 7.55652C3.86263 7.41642 4.05189 7.33657 4.25 7.33398Z" fill={`url(#paint0_linear_13065_504837_${props.idKey || "0"})`}/>
          <defs>
          <linearGradient id={`paint0_linear_13065_504837_${props.idKey || "0"}`} x1="8" y1="0.333984" x2="8" y2="10.334" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FF0016"/>
          <stop offset="1" stopColor="#FF9900"/>
          </linearGradient>
          </defs>
          </svg>
          
        ) : undefined}
        <span>
          {props.totalPicks} Pick{props.totalPicks != 1 ? "s" : ""}
        </span>
      </div>
      
      {props.totalComments && props.totalComments > 0 ? (
        <div className="flex flex-row items-center gap-2">
          <div className="w-px h-4 bg-secondary-700"></div>
          <div className="w-full flex flex-row gap-1">
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.28441 12.9072C5.11129 13.2878 6.03146 13.5 7.00001 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7.00001 0.5C3.41015 0.5 0.500006 3.41015 0.500006 7C0.500006 8.24557 0.850789 9.41044 1.45903 10.3998L0.529691 12.8724C0.470899 13.0288 0.500699 13.2047 0.60772 13.333C0.71474 13.4614 0.882469 13.5223 1.04691 13.4926L4.28441 12.9072ZM3.51786 5.60714C3.51786 5.22252 3.82966 4.91071 4.21429 4.91071H9.78571C10.1703 4.91071 10.4821 5.22252 10.4821 5.60714C10.4821 5.99177 10.1703 6.30357 9.78571 6.30357H4.21429C3.82966 6.30357 3.51786 5.99177 3.51786 5.60714ZM3.51786 8.39286C3.51786 8.00823 3.82966 7.69643 4.21429 7.69643H7.92857C8.3132 7.69643 8.625 8.00823 8.625 8.39286C8.625 8.77748 8.3132 9.08929 7.92857 9.08929H4.21429C3.82966 9.08929 3.51786 8.77748 3.51786 8.39286Z"
                fill={`url(#paint0_linear_13065_504777_${props.idKey || "0"})`}
              />
              <defs>
                <linearGradient
                  id={`paint0_linear_13065_504777_${props.idKey || "0"}`}
                  x1="7"
                  y1="0.5"
                  x2="7"
                  y2="13.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FF0016" />
                  <stop offset="1" stopColor="#FF9900" />
                </linearGradient>
              </defs>
            </svg>
          {formatNumber(props.totalComments, true)}
          </div>
        </div>
      ) : undefined}
      {props.totalPicks > 0 &&
      props.showAvatars !== undefined &&
      props.showAvatars ? (
        <>
          <div className="w-px h-5 bg-secondary-700"></div>
          <PickGroup
            avatars={props.avatars || []}
            totalBettors={props.totalBettors || 0}
            totalPicksForSale={props.totalPicksForSale}
            side={props.side}
            dark={props.dark}
          />
        </>
      ) : undefined}
    </div>
  );
}
